import React from "react";
import Common_breadcrumb from "../common_components/common-breadcrumb/Common_breadcrumb";

function Privacy_policy() {
  const breadcrumbsData = [
    { name: "HOMEPAGE", href: "/" },
    { name: "PRIVACY POLICY", active: true },
  ];
  return (
    <>
      <section className=" Terms_and_condition">
        <Common_breadcrumb
          pageName="PRIVACY POLICY"
          bgImage="/assets/images/Privacy_policy/bg/bg.png"
          breadcrumbs={breadcrumbsData}
        />
        <div className="policy_text_holder">
          <div className="container">
            <div className="text_holder">
              <p>
                We value your privacy. This Privacy Policy explains how{" "}
                <b>MY MDS </b>
                collects, uses, and protects information when schools and
                students use our driving theory learning application.
              </p>

              <h3>1. Information We Collect</h3>
              <ul>
                <li>
                  <strong>From Driving Schools:</strong> name, contact details,
                  aadhaar, PAN details.
                </li>
                <li>
                  <strong>From Students:</strong> name, email, phone, login
                  credentials, aadhaar, PAN details.
                </li>
                <li>
                  <strong>Automatically:</strong> device type, IP address, app
                  usage statistics, crash reports.
                </li>
              </ul>

              <h3>2. How We Use Your Information</h3>
              <ul>
                <li>
                  Provide driving theory courses and track student progress.
                </li>
                <li>Generate school-level reports and analytics.</li>
                <li>
                  Improve application features, security, and performance.
                </li>
                <li>Communicate important updates or reminders.</li>
              </ul>

              <h3>3. Consent & Children’s Privacy</h3>
              <ul>
                <li>
                  Driving Schools must obtain consent from parents/guardians of
                  minors.
                </li>
                <li>
                  Students under 18 require parental consent to use the
                  Platform.
                </li>
                <li>
                  We do not use children’s data for advertising or profiling.
                </li>
              </ul>

              <h3>4. Data Sharing & Disclosure</h3>
              <ul>
                <li>With Driving Schools (e.g., student progress reports).</li>
                <li>
                  With trusted service providers (e.g., hosting, analytics).
                </li>
                <li>With government authorities if legally required.</li>
                <li>We never sell student data to third parties.</li>
              </ul>

              <h3>5. Data Retention</h3>
              <ul>
                <li>
                  We retain school and student data as long as the subscription
                  is active.
                </li>
                <li>
                  Upon request or account termination, we delete or anonymize
                  data within 30 days.
                </li>
              </ul>

              <h3>6. Security Measures</h3>
              <ul>
                <li>
                  We use encryption (e.g., AES-256), HTTPS, and strict access
                  controls.
                </li>
                <li>
                  Regular audits are conducted to prevent unauthorized access.
                </li>
              </ul>

              <h3>7. User Rights</h3>
              <p>Students and schools have the right to:</p>
              <ul>
                <li>Access their personal data.</li>
                <li>Request correction or updates.</li>
                <li>Request deletion of their data.</li>
                <li>Withdraw consent at any time.</li>
              </ul>

              <h3>8. Changes to Privacy Policy</h3>
              <ul>
                <li>We may update this Policy periodically.</li>
                <li>Driving Schools will be notified of major changes.</li>
              </ul>

              <h3>9. Contact Information</h3>
              <p>
                For questions, complaints, or data requests, please contact:
                <b> mymds2026@gmail.com</b>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Privacy_policy;
